import React, { useState } from 'react';
import { connect } from 'react-redux';
import SummaryInfoSC from './summary-info.styled';
import Button from '../../ui/button';
import { BodyText, SmallText, HeadingFour } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import DocumentsVerification from '../documents-verification';
import InlineLoading from '../../ui/inline-loading';

const SummaryInfo = ({ onClick, documents, onBoardingStepData, sendingStatus }) => {
  const [sectionIsRead, setSectionIsRead] = useState({
    frameworkContract: false,
    consumerSummary: false,
    powerOfAttorney: false,
    all: false,
  });

  const setSectionRead = (section, status) => {
    setSectionIsRead((o) => {
      const newState = { ...o, [section]: status };
      delete newState.all;
      newState.all = Object.values(newState).every(Boolean);
      return newState;
    });
  };

  const isObject = (a) => {
    return !!a && a.constructor === Object;
  };

  if (isObject(onBoardingStepData.address)) {
    return (
      <SummaryInfoSC>
        <InlineLoading />
      </SummaryInfoSC>
    );
  }

  return (
    <SummaryInfoSC>
      <DocumentsVerification
        title={'onboarding_investor_documents_title_framework_contract'}
        documents={documents.frameworkContract}
        setDocumentsToAllRead={(status) => setSectionRead('frameworkContract', status)}
      />
      <DocumentsVerification
        title={'onboarding_investor_documents_title_consumer_summary'}
        documents={documents.consumerSummary}
        setDocumentsToAllRead={(status) => setSectionRead('consumerSummary', status)}
      />
      <DocumentsVerification
        title={'onboarding_investor_documents_title_power_of_attorney'}
        documents={documents.powerOfAttorney}
        setDocumentsToAllRead={(status) => setSectionRead('powerOfAttorney', status)}
      />
      <div className="additional-data-wrap">
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedMessage
              id="onboarding_summary_info_investor_client"
              defaultMessage={dlt['onboarding_summary_info_investor_client']}
            />
          </SmallText>
          <HeadingFour>{onBoardingStepData.full_name}</HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedMessage
              id="onboarding_summary_info_investor_personal_identification_number"
              defaultMessage={
                dlt['onboarding_summary_info_investor_personal_identification_number']
              }
            />
          </SmallText>
          <HeadingFour>{onBoardingStepData.personal_identification_number}</HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedMessage
              id={`onboarding_identity_document_type_${onBoardingStepData.personal_documents[0].type_name}`}
              defaultMessage={
                dlt[
                  `onboarding_identity_document_type_${onBoardingStepData.personal_documents[0].type_name}`
                ]
              }
            />
          </SmallText>
          <HeadingFour>{onBoardingStepData.personal_documents[0].document_number} </HeadingFour>
        </div>
        <div className="additional-data-wrap--item">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedMessage
              id={`onboarding_identity_document_type_${onBoardingStepData.personal_documents[1].type_name}`}
              defaultMessage={
                dlt[
                  `onboarding_identity_document_type_${onBoardingStepData.personal_documents[1].type_name}`
                ]
              }
            />
          </SmallText>
          <HeadingFour> {onBoardingStepData.personal_documents[1].document_number}</HeadingFour>
        </div>

        <div className="additional-data-wrap--item full-width">
          <SmallText className="black-transparent-lighter smaller bolder">
            <FormattedHTMLMessage
              id="onboarding_summary_info_investor_address"
              defaultMessage={dlt['onboarding_summary_info_investor_address']}
            />
          </SmallText>
          <HeadingFour>{onBoardingStepData.address}</HeadingFour>
        </div>
      </div>
      <div className="bottom-wrap">
        <BodyText className="hint-text">
          <FormattedHTMLMessage
            id="onboarding_continue_hint"
            defaultMessage={dlt['onboarding_continue_hint']}
          />
        </BodyText>
        <div className="half-wrap">
          <Button
            type="OUTLINED"
            size="BIG"
            disabled={sendingStatus === 'sending'}
            onClick={() => onClick('declined')}
          >
            <FormattedMessage
              id="global_change_infos"
              defaultMessage={dlt['global_change_infos']}
            />
          </Button>
          <Button type="PRIMARY" disabled={!sectionIsRead.all} onClick={() => onClick('accepted')}>
            <FormattedMessage id="global_continue" defaultMessage={dlt['global_continue']} />
          </Button>
        </div>
      </div>
    </SummaryInfoSC>
  );
};

const mapStateToProps = (state) => ({
  sendingStatus: state.onboarding.sending_status,
});

export default connect(mapStateToProps)(SummaryInfo);
